import {
    SET_INSTRUCTOR_COUPONS,
    ADD_INSTRUCTOR_COUPON,
    UPDATE_INSTRUCTOR_COUPON,
    DELETE_INSTRUCTOR_COUPON
} from 'store/reducers/instructorReducer'
import moment from 'moment-timezone'
import {apiRequest} from 'util/api/util'

export const loadCoupons = () => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        // const state = getState()
        const partnerId = getState().instructor.instructor.platformID
        const db = getFirestore()
        console.log("Loading coupons")
        console.log(partnerId)
        return apiRequest("app/coupons?partnerId=" + partnerId)
            .then(coupons => {
                dispatch({type: SET_INSTRUCTOR_COUPONS, coupons: coupons})
                return coupons
            })
    }
}

export const deleteCoupon = (coupon) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        coupon = {
            ...coupon,
            is_enabled: false,
            deleted: true
        }

        return apiRequest("app/coupon?couponId=" + coupon.id, "PUT", {coupon: coupon})
            .then(res => {
                dispatch({type: UPDATE_INSTRUCTOR_COUPON, coupon: res})
                return res
            })
    }
}

export const saveCoupon = (coupon) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        const state = getState()

        coupon = {
            ...coupon,
            partnerId: state.instructor.instructor.platformID,
            deleted: false,
            is_enabled: true
        }

        if (coupon.id) { // update
            coupon.updated = moment().unix()

            return apiRequest("app/coupon?couponId=" + coupon.id, "PUT", {coupon: coupon})
                .then(res => {
                    dispatch({type: UPDATE_INSTRUCTOR_COUPON, coupon: res})
                    return res
                })
        } else { // add new
            coupon.created = moment().unix()
            return apiRequest("app/coupon", "POST", {coupon: coupon})
                .then(res => {
                    dispatch({type: ADD_INSTRUCTOR_COUPON, coupon: res})
                    return res
                })
        }
    }
}